import apiClient from './api';

export interface CourseSyncCourse {
  sourceSystemCourseId: string;
  title: string;
  outcome: 'Added' | 'Updated' | 'Unchanged';
  instancesActive: number;
  instancesInactivated: number;
}

export interface CourseSyncResult {
  pulledCount: number;
  scheduledInstanceCount: number;
  processedCount: number;
  addedCount: number;
  updatedCount: number;
  unchangedCount: number;
  courses: CourseSyncCourse[];
}

const courseSyncService = {
  async syncDocebo(): Promise<CourseSyncResult> {
    const response = await apiClient.post<CourseSyncResult>('/api/course-sync/docebo');
    return response.data;
  },

  async syncWebinars(): Promise<CourseSyncResult> {
    const response = await apiClient.post<CourseSyncResult>('/api/course-sync/webinars');
    return response.data;
  },
};

export default courseSyncService;
